import { render, staticRenderFns } from "./AgentWithdrawalRequests.vue?vue&type=template&id=c07553dc&"
import script from "./AgentWithdrawalRequests.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports